import { createAction } from '@reduxjs/toolkit';

const saveQueryData = createAction<
  {
    queryKey: string;
    data?: any;
    status?: 'idle' | 'pending' | 'success' | 'error';
  },
  'query/SAVE_QUERY_DATA'
>('query/SAVE_QUERY_DATA');

const deleteQueryData = createAction<
  {
    queryKey: string;
  },
  'query/DELETE_QUERY_DATA'
>('query/DELETE_QUERY_DATA');

export { deleteQueryData, saveQueryData };
